/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_No_Internet_ContentInputs */

const en_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check your internet connection or switch to a different network and try again.`)
};

const ar_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى التحقق من اتصالك بالإنترنت أو التبديل إلى شبكة مختلفة والمحاولة مرة أخرى.`)
};

const de_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte überprüfen Sie Ihre Internetverbindung oder wechseln Sie zu einem anderen Netzwerk und versuchen Sie es erneut.`)
};

const es_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprueba tu conexión a Internet o cambia a otra red e inténtalo de nuevo.`)
};

const fr_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez vérifier votre connexion internet ou changez de réseau puis réessayez.`)
};

const it_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla la tua connessione internet o passa a una rete diversa e prova di nuovo.`)
};

const ja_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インターネット接続を確認するか、別のネットワークに切り替えて再度お試しください。`)
};

const ko_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인터넷 연결을 확인하거나 다른 네트워크로 전환한 뒤 다시 시도하세요.`)
};

const pt_br_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confira sua conexão com a internet ou troque para outra rede e tente novamente.`)
};

const ru_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверьте интернет-соединение или переключитесь на другую сеть и повторите попытку.`)
};

const th_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณหรือเปลี่ยนไปใช้เครือข่ายอื่นแล้วลองอีกครั้ง`)
};

const tr_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen internet bağlantını kontrol et veya başka bir ağa geçip tekrar dene.`)
};

const zh_cn_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请检查连线状态或更换网络再试试`)
};

const zh_tw_dialog_no_internet_content = /** @type {(inputs: Dialog_No_Internet_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請檢查連線狀態或更換網路再試試`)
};

/**
* | output |
* | --- |
* | "Please check your internet connection or switch to a different network and try again." |
*
* @param {Dialog_No_Internet_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_no_internet_content = /** @type {((inputs?: Dialog_No_Internet_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_No_Internet_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_no_internet_content(inputs)
	if (locale === "ar") return ar_dialog_no_internet_content(inputs)
	if (locale === "de") return de_dialog_no_internet_content(inputs)
	if (locale === "es") return es_dialog_no_internet_content(inputs)
	if (locale === "fr") return fr_dialog_no_internet_content(inputs)
	if (locale === "it") return it_dialog_no_internet_content(inputs)
	if (locale === "ja") return ja_dialog_no_internet_content(inputs)
	if (locale === "ko") return ko_dialog_no_internet_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_no_internet_content(inputs)
	if (locale === "ru") return ru_dialog_no_internet_content(inputs)
	if (locale === "th") return th_dialog_no_internet_content(inputs)
	if (locale === "tr") return tr_dialog_no_internet_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_no_internet_content(inputs)
	return zh_tw_dialog_no_internet_content(inputs)
});